// extracted by mini-css-extract-plugin
export default {"answer":"_b263a17a"};